import { useFormContext } from 'react-hook-form';
import type { PostgresConfigWithInstances } from '@/enteties/postgresql/model';
import { useCallback } from 'react';
import { downloadConfigFile, DOCS_DOMAIN } from 'shared/lib/util';
import { Alert, AlertDescription } from 'shared/ui/alert';
import { Info } from 'lucide-react';
import { DocsIconHelper } from 'shared/ui/tooltips';
import { Button } from 'shared/ui/button';
import { ConfigFormSetter } from 'widgets/project-creation-stepper/ui/config-component/config-form-setter';
import * as m from '@paraglide/messages';
export const AppConfigComponent = () => {
  const {
    getValues
  } = useFormContext<PostgresConfigWithInstances>();
  const downloadYml = useCallback(() => {
    const values = getValues();
    downloadConfigFile(values);
  }, [getValues]);
  return <div data-sentry-component="AppConfigComponent" data-sentry-source-file="app-config.tsx">
      <Alert size="sm" variant="info" className="mb-4" data-sentry-element="Alert" data-sentry-source-file="app-config.tsx">
        <Info className="size-5 p-0.5" data-sentry-element="Info" data-sentry-source-file="app-config.tsx" />
        <AlertDescription className="" data-sentry-element="AlertDescription" data-sentry-source-file="app-config.tsx">
          {m.create_dialog_step_config_alert()}
        </AlertDescription>
      </Alert>
      <div className="flex gap-2 md:min-w-96 items-center mb-6">
        <span>{m.create_dialog_step_config_title()}</span>
        <DocsIconHelper href={`${DOCS_DOMAIN}/applications/configuration/config-file.html`} data-sentry-element="DocsIconHelper" data-sentry-source-file="app-config.tsx" />
      </div>

      <ConfigFormSetter data-sentry-element="ConfigFormSetter" data-sentry-source-file="app-config.tsx" />

      {/* <div className="mb-4"> */}
      {/*  <Separator /> */}
      {/*  <Accordion type="single" collapsible> */}
      {/*    <AccordionItem value="additionalSettings" className="pr-4"> */}
      {/*      <AccordionTrigger className="text-title4"> */}
      {/*        Продвинутые настройки */}
      {/*      </AccordionTrigger> */}
      {/*      <AccordionContent> */}
      {/*        <div className="flex justify-between"> */}
      {/*          <h1>Переменные</h1> */}
      {/*          <div className="flex gap-2"> */}
      {/*            <AddVariable text="Создать секрет" isSecret /> */}
      {/*            <AddVariable text="Создать переменную" /> */}
      {/*          </div> */}
      {/*        </div> */}
      {/*      </AccordionContent> */}
      {/*    </AccordionItem> */}
      {/*  </Accordion> */}
      {/* </div> */}

      <Button type="button" className="text-status-tertiary p-0 h-fit" onClick={downloadYml} variant="link" size="sm" data-sentry-element="Button" data-sentry-source-file="app-config.tsx">
        {m.create_dialog_step_config_downloadConfig()}
      </Button>
    </div>;
};